/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Sign_OutInputs */



/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {Profile_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_sign_out = /** @type {((inputs?: Profile_Sign_OutInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Sign_OutInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se déconnecter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar sesión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sair")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esci")
	return /** @type {LocalizedString} */ ("Sign Out")
});